import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: 200,
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    margin: '20px 15px',
    flexWrap: 'wrap'
  },
  select: {
    marginBottom: '.5rem'
  },
  order: {
    marginBottom: '.5rem',
    fontWeight: 'bold'
  },
  recapContainer: {
    flex: 0.3,
    minWidth: 235
  },
  recap: {
    marginBottom: '.5rem',
    fontWeight: 'bold'
  },
  recapInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& h5': {
      fontWeight: 'bold'
    }
  },
  priceContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-evenly',
    margin: '25px 0'
  },
  price: {
    color: '#002380',
    fontSize: 21,
    fontWeight: 'bold',
    margin: '5px 0'
  },
  input: {
    width: 225,
    minHeight: 50,
    padding: 10,
    border: '2px solid #002380',
    borderRadius: '5px',
    fontSize: 15,
    fontWeight: 'bold',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  percentContainer: {
    width: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '10px 0',
    '& span': {
      marginLeft: 2,
      color: '#002380',
      fontWeight: 600
    }
  },
  orderAmount: {
    minWidth: 225
  }
}));

const Step2 = ({
  order,
  currency,
  valuation,
  setValuation,
  sharesNumber,
  setSharesNumber,
  sharePrice,
  setSharePrice,
  valuationPercent,
  setValuationPercent,
  dealSize,
  sharesNum,
  unitPrice
}) => {
  const classes = useStyles();

  const abbreviateNumber = (value) => {
    if (value <= 1000) {
      return value;
    }
    const mappings = {
      K: [1000, 999999],
      M: [1000000, 999999999],
      B: [1000000000, 999999999999],
      T: [1000000000000, 999999999999999]
    };
    for (const abbr in mappings) {
      if (
        Math.abs(value) >= mappings[abbr][0] &&
        Math.abs(value) <= mappings[abbr][1]
      ) {
        return (value / mappings[abbr][0]).toFixed(0) + abbr;
      }
    }
    return value;
  };

  const renderPrice = (value, valuepercent, sharesnumber, shareprice) => {
    if (order.value === 1) return +(value * (valuepercent / 100)).toFixed(2);
    if (order.value === 2) return +(sharesnumber * shareprice).toFixed(2);
  };

  // const numberFormater = (value) => {
  //   return value.toLocaleString('en', { maximumFractionDigits: 2 });
  // };

  const renderCurrency = (value) => {
    switch (value) {
      case 1:
        return '€';
      case 2:
        return '$';
      default:
        return '$';
    }
  };

  const renderOrderAmount = (value) => {
    switch (value) {
      case 1:
        return renderPrice(valuation, valuationPercent, null, null);
      case 2:
        return renderPrice(null, null, sharesNumber, sharePrice);
      default:
        return 0;
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.priceContainer}>
        <div className={classes.recapContainer}>
          <Typography gutterBottom className={classes.recap} variant="h4">
            Recap of the deal
          </Typography>
          <div className={classes.recapInfo}>
            <Typography gutterBottom className={classes.select} variant="h5">
              Fund raising
            </Typography>
            <Typography gutterBottom className={classes.select} variant="h6">
              xxxxxxxxx
            </Typography>
          </div>
          <div className={classes.recapInfo}>
            <Typography gutterBottom className={classes.select} variant="h5">
              Deal size
            </Typography>
            <Typography gutterBottom className={classes.select} variant="h6">
              {abbreviateNumber(dealSize)}
            </Typography>
          </div>
          <div className={classes.recapInfo}>
            <Typography gutterBottom className={classes.select} variant="h5">
              Equiv Nber of shares
            </Typography>
            <Typography gutterBottom className={classes.select} variant="h6">
              {abbreviateNumber(sharesNum)}
            </Typography>
          </div>
          <div className={classes.recapInfo}>
            <Typography gutterBottom className={classes.select} variant="h5">
              Unit price
            </Typography>
            <Typography gutterBottom className={classes.select} variant="h6">
              {`${renderCurrency(currency.value)} ${unitPrice}`}
            </Typography>
          </div>
        </div>
        <div>
          <Typography gutterBottom className={classes.order} variant="h4">
            Your order
          </Typography>
          {order.value === 1 ? (
            <>
              <Typography gutterBottom className={classes.select} variant="h5">
                Deal size
              </Typography>
              <div className={classes.percentContainer}>
                <input
                  className={classes.input}
                  name="input"
                  type="number"
                  value={valuation}
                  onChange={(e) => setValuation(e)}
                />
                <span>{renderCurrency(currency.value)}</span>
              </div>
              <Typography gutterBottom className={classes.select} variant="h5">
                Order size
              </Typography>
              <div className={classes.percentContainer}>
                <input
                  className={classes.input}
                  name="input"
                  type="number"
                  value={valuationPercent}
                  onChange={(e) => setValuationPercent(e)}
                />
                <span>%</span>
              </div>
            </>
          ) : (
            <>
              <Typography gutterBottom className={classes.select} variant="h5">
                Price per share
              </Typography>
              <div className={classes.percentContainer}>
                <input
                  className={classes.input}
                  name="input"
                  type="number"
                  value={sharePrice}
                  onChange={(e) => setSharePrice(e)}
                />
                <span>{renderCurrency(currency.value)}</span>
              </div>
              <Typography gutterBottom className={classes.select} variant="h5">
                Number of shares
              </Typography>
              <div className={classes.percentContainer}>
                <input
                  className={classes.input}
                  name="input"
                  type="number"
                  value={sharesNumber}
                  onChange={(e) => setSharesNumber(e)}
                />
              </div>
            </>
          )}
        </div>
        <div className={classes.orderAmount}>
          <div>
            <>
              <Typography gutterBottom className={classes.order} variant="h4">
                Order amount
              </Typography>
              <h5 className={classes.price}>{`${renderCurrency(
                currency.value
              )}${renderOrderAmount(order.value)}`}</h5>
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

Step2.propTypes = {
  currency: PropTypes.object.isRequired,
  dealSize: PropTypes.number.isRequired,
  order: PropTypes.object.isRequired,
  sharesNumber: PropTypes.number.isRequired,
  unitPrice: PropTypes.number.isRequired
};

export default Step2;
